import React from "react";
import { useLanguage } from "../context/LanguageContext";

const About = () => {
  const { t } = useLanguage();
  return (
    <section id="about" data-testid="about-section" className="relative bg-[#F7F5F2] py-32 lg:py-44">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid lg:grid-cols-12 gap-16 lg:gap-24 items-start">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-8">
              <span className="w-14 h-px bg-[#B08D57]"></span>
              <span className="overline-bold text-[#B08D57]">{t.about.overline}</span>
            </div>
            <div className="relative aspect-[4/5] overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_precision-build-25/artifacts/29da9j9s_IMG_2388.jpeg"
                alt="MITROLLARI craftsmanship"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1500ms]"
              />
              <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/75 to-transparent"></div>
              <div className="absolute bottom-7 left-7 right-7">
                <div className="overline text-[#B08D57]">{t.about.established}</div>
                <div className="text-white text-sm mt-2.5 tracking-[0.22em] font-semibold">{t.about.coverage}</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pt-16">
            <h2 className="font-display-thin text-[#0F0F0F] text-3xl sm:text-4xl lg:text-[54px] tracking-tight leading-[1.08]">
              {t.about.title}
            </h2>
            <div className="mt-12 space-y-7 text-[#3A3A37] text-base sm:text-[17px] leading-[1.8]">
              <p>{t.about.body_1}</p>
              <p>{t.about.body_2}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
